import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = (exception) => {
	try {
		const exceptionMsg = exception.response?.data?.message || exception.response?.data?.error;
		const exceptionComplement = exception.response?.data?.complement;

		const isExceptionPredicted = !!(exceptionMsg);
		const doesExceptionContainTranslation = i18n.exists(`backendErrors.${exceptionMsg}`);
		const doesExceptionComplementExist = !!(exceptionComplement);
		const isExceptionOtherOpenTicket = exceptionMsg === "ERR_OTHER_OPEN_TICKET";

		if (isExceptionPredicted && doesExceptionContainTranslation) {
			if (doesExceptionComplementExist) {
				const subMessage = isExceptionOtherOpenTicket ? i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET_USER") : "";
				const message = `${i18n.t(`backendErrors.${exceptionMsg}`)} ${subMessage} ${exceptionComplement}.`;
				toast.error(message, { toastId: exceptionMsg });
			}

			else if (isExceptionOtherOpenTicket) {
				toast.error(i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET_EXCEPTION"), { toastId: exceptionMsg });
			}

			else {
				toast.error(i18n.t(`backendErrors.${exceptionMsg}`), { toastId: exceptionMsg });
			}
		}
		else if (isExceptionPredicted) {
			toast.error(exceptionMsg, { toastId: exceptionMsg });
		}
		else {
			console.log("- ❌ Toast Error not Treated Message:", exception);
			toast.error("❌ Entre em contato com o suporte para ajuda!");
		}
	} catch (exception) {
		console.log("- Toast Error Exception Message:", exception);
	}
};

export default toastError;
